import { atom } from "recoil";
import { Product } from "../model";

export const productsState = atom<Product[] | undefined>({
  key: 'productsState',
  default: undefined,
});